import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Typography,
  TextField,
  Grid,
  Button,
  CircularProgress,
  Card,
  CardContent
} from '@material-ui/core';
import { solicitudDetalleService } from '../../services';

const SeccionDatosPrincipalesIndividuo = ({ solicitudId }) => {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [formData, setFormData] = useState({
    nombres: '',
    apellidos: '',
    celular: '',
    correoElectronico: '',
    comoNosConocio: ''
  });

  const cargarDatos = useCallback(async () => {
    try {
      setLoading(true);
      setError('');
      const response = await solicitudDetalleService.getDatosPrincipalesIndividuo(solicitudId);
      if (response) {
        setFormData({
          nombres: response.nombres || '',
          apellidos: response.apellidos || '',
          celular: response.celular || '',
          correoElectronico: response.correoElectronico || '',
          comoNosConocio: response.comoNosConocio || ''
        });
      }
    } catch (err) {
      setError('Error al cargar los datos principales');
    } finally {
      setLoading(false);
    }
  }, [solicitudId]);

  useEffect(() => {
    cargarDatos();
  }, [cargarDatos]);

  const handleInputChange = (field, value) => {
    if (field === 'celular') {
      const numericValue = value.replace(/[^0-9]/g, '');
      setFormData(prev => ({ ...prev, [field]: numericValue }));
    } else {
      setFormData(prev => ({ ...prev, [field]: value }));
    }
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    setSuccess('');

    if (!validateEmail(formData.correoElectronico)) {
      setError('Ingrese un correo electrónico válido');
      setSaving(false);
      return;
    }

    try {
      const datosParaGuardar = {
        solicitudId: parseInt(solicitudId),
        nombres: formData.nombres,
        apellidos: formData.apellidos,
        celular: formData.celular,
        correoElectronico: formData.correoElectronico,
        comoNosConocio: formData.comoNosConocio
      };
      await solicitudDetalleService.saveDatosPrincipalesIndividuo(datosParaGuardar);
      setSuccess('Datos guardados exitosamente');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError('Error al guardar los datos');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Datos Principales
        </Typography>
        {error && (
          <Box p={2} mb={2} style={{ backgroundColor: '#ffebee', color: '#c62828', borderRadius: '4px' }}>
            <Typography variant="body2">{error}</Typography>
          </Box>
        )}
        {success && (
          <Box p={2} mb={2} style={{ backgroundColor: '#e8f5e9', color: '#2e7d32', borderRadius: '4px' }}>
            <Typography variant="body2">{success}</Typography>
          </Box>
        )}
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Nombres"
                required
                value={formData.nombres}
                onChange={(e) => handleInputChange('nombres', e.target.value)}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Apellidos"
                required
                value={formData.apellidos}
                onChange={(e) => handleInputChange('apellidos', e.target.value)}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Celular"
                required
                value={formData.celular}
                onChange={(e) => handleInputChange('celular', e.target.value)}
                variant="outlined"
                type="tel"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Correo Electrónico"
                required
                value={formData.correoElectronico}
                onChange={(e) => handleInputChange('correoElectronico', e.target.value)}
                variant="outlined"
                type="email"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="¿Cómo nos conoció?"
                required
                value={formData.comoNosConocio}
                onChange={(e) => handleInputChange('comoNosConocio', e.target.value)}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={saving}
              >
                {saving ? <CircularProgress size={20} /> : 'Guardar'}
              </Button>
            </Grid>
          </Grid>
        </form>
      </CardContent>
    </Card>
  );
};

export default SeccionDatosPrincipalesIndividuo;

